import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { CommonService } from './core/services/common.service';
import { SessionTimeoutService } from './core/services/session-timeout.service';
import { UserService } from './core/services/user-service.service';
import { filter } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'bridge_civic';

  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private router: Router,
    private sessionTimeoutService: SessionTimeoutService,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    // Check authentication state when app initializes
    this.authService.checkAuthState();
    this.commonService.getLocation().then((res) => { });

    // Initialize session timeout tracking
    this.sessionTimeoutService.init();

    // Subscribe to router events to check for token on every navigation
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.checkForTokenInUrl();
    });

    // Also check on initial load
    this.checkForTokenInUrl();
  }

  private checkForTokenInUrl(): void {
    // Get the current URL query parameters
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');

    if (token) {
      // First, decode the token
      const decodedToken = this.authService.processSSOToken(token);

      // Update auth state
      const isLoggedIn = this.authService.checkAuthState();

      // Remove token from URL to prevent it from being visible
      // and to avoid saving it again on page refresh
      let currentUrl = window.location.pathname;

      if (!isLoggedIn) {
        currentUrl = '/auth/login';
      } else {
        // Check if profile is completed after SSO login
        const user = this.userService.getUserDetails();
        const isProfileCompleted = user?.isProfileCompleted || false;

        // If profile is not completed and not already on profile page, redirect to profile
        if (!isProfileCompleted && !currentUrl.includes('/user/profile')) {
          currentUrl = '/user/profile';
        }
      }

      // Navigate to the clean URL without the token parameter
      this.router.navigateByUrl(currentUrl, { replaceUrl: true });
    }
  }
}
